import {
  TAGGLE_SEARCH_BAR,
  TAGGLE_HAMBURGER_MENU
} from "../../utils/mutationType";

export default {
  namespaced: true,
  state: {
    showSearchBar: false,
    showHamburgerMenu: false
  },

  mutations: {
    [TAGGLE_SEARCH_BAR](state) {
      state.showSearchBar = !state.showSearchBar;
    },
    [TAGGLE_HAMBURGER_MENU](state, showHamburgerMenu) {
      state.showHamburgerMenu = showHamburgerMenu;
    }
  }
};
